const autocompleteModalCloneCheck = {
  serviceType: 'Tipo de Servicio',
  frequency: 'Periodicidad',
  mandatory: 'El servicio es obligatorio?' 
};

export default autocompleteModalCloneCheck;
